module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_2.70ecb968.png";